import api from '@/shared/api';
import type { ApiResponse, BulkDeleteResult, Pagination, SortOrder } from '@/shared/lib';
import type { ModelCategory } from '../model/models.types';

export type MatrixModelSearchType = 'title' | 'category';

export type MatrixModelSortField = 'createdAt' | 'title';

export interface MatrixModelResponse {
  id: number;
  title: string;
  categories: ModelCategory[];
}

export interface ListMatrixModelsParams {
  page: number;
  itemsPerPage: number;
  term?: string;
  searchType?: MatrixModelSearchType;
  sort?: MatrixModelSortField;
  order?: SortOrder;
  createdAt?: string;
  categoryIds?: number[];
  createdBy?: number;
}

interface PaginatedEnvelope<T> {
  data: T[];
  metadata: Pagination;
}

export async function listMatrixModels(
  params: ListMatrixModelsParams
): Promise<PaginatedEnvelope<MatrixModelResponse>> {
  const { categoryIds, ...rest } = params;
  const response = await api.get<PaginatedEnvelope<MatrixModelResponse>>('/matrix-models', {
    params: {
      ...rest,
      ...(categoryIds?.length ? { categoryIds: categoryIds.join(',') } : {}),
    },
  });
  return { data: response.data.data, metadata: response.data.metadata };
}

export async function renameMatrixModel(id: number, title: string): Promise<void> {
  await api.put(`/matrix-models/${id}`, { title });
}

export async function deleteMatrixModels(ids: number[]): Promise<{ data: BulkDeleteResult }> {
  const response = await api.delete<ApiResponse<BulkDeleteResult>>('/matrix-models/bulk', {
    data: { ids },
  });

  return { data: response.data.data! };
}
